<script lang="ts">
    import EditAlternativePage from '@Alternatives/Alternatives/Pages/EditAlternativePage'
    export default EditAlternativePage
</script>

<template>
    <div v-if="rm">
        <nav class="navbar navbar-expand-sm navbar-light bg-light fixed-top">
            <div class="container justify-content-end">
                <button type="submit" class="btn btn-lg btn-success" form="editAlternativePageAlternativeForm">Save Changes</button>
            </div>
        </nav>

        <div class="container">
            <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">Edit <span style="text-transform: lowercase;">{{rm.AlternativeLabel}}</span></h1>

            <hr style="border-color: #bbb; margin: 20px 0 30px;" />

            <div class="alert alert-warning" role="alert">
                Please remember to press Save Changes before refreshing this page and when the questionnaire is complete!
            </div>

            <AlternativeEditor :propRm="rm.AlternativeEditor" :propErrors="errors" propFormId="editAlternativePageAlternativeForm"
                               @form-submit="save" />
        </div>

    </div>
</template>

